import request, { get, put } from './httpService';

const base = '/eyeexamtemplates';

export const EyeExamTemplateService = {
  list(practitionerId, includePublic = true, signal) {
    return get({ url: `${base}`, params: { practitionerId, includePublic }, signal }).then(res => res.data);
  },
  getById(id, signal) {
    return get({ url: `${base}/${id}`, signal }).then(res => res.data);
  },
  create(record) {
    return request({ method: 'POST', url: `${base}/new`, data: record }).then(res => res.data);
  },
  update(id, record) {
    return put({ url: `${base}/${id}`, data: record }).then(res => res.data);
  },
  delete(id) {
    return request({ method: 'DELETE', url: `${base}/${id}` }).then(res => res.data);
  }
};
